module.exports = __webpack_public_path__ + "img/4.efba2232.jpg";